import { Component, OnInit, Output, EventEmitter, Input, ElementRef, AfterViewChecked } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

export interface CustomDateModel {
  from: Date;
  to: Date;
  oriFrom: Date;
  oriTo: Date;
}
@Component({
  selector: 'app-ci-custom-date-selector',
  templateUrl: './ci-custom-date-selector.component.html',
  styleUrls: ['./ci-custom-date-selector.component.scss'],
  standalone: false
})
export class CiCustomDateSelectorComponent implements OnInit, AfterViewChecked {
  @Output() applyDate = new EventEmitter<any>();
  @Input() conditionCode: string = '';
  @Input() setMinDate = { min: null, max: null, intialRow: null, index: null, isEdit: false };
  @Input() disableEndDate: any;
  @Input() selection: any;
  @Input() datePickerMinDate: Date;

  customDate: CustomDateModel;
  today: Date;
  startDate: Date;
  startDateFrom: Date;
  fromMinDate: Date;
  minYear: number;
  maxYear: number;
  selectionCorrect: any = false;
  isDisable = {
    from: false,
    to: false
  };
  public endDate: Date;
  disableMindate: Date;
  disableDates: Date[] = [];

  constructor(
    public utilSer: UtilsService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    const thisInstant = +new Date();
    this.today = new Date(this.utilSer.timeStampConverter(thisInstant, false));
    const tempToday = new Date(this.utilSer.timeStampConverter(thisInstant, false));
    this.selectionCorrect = false;

    this.maxYear = this.today.getFullYear();
    this.minYear = this.maxYear - 3;

    const threeYearsAgo = new Date(this.today);
    threeYearsAgo.setFullYear(this.minYear);

    this.fromMinDate = (this.datePickerMinDate && this.datePickerMinDate > threeYearsAgo)
      ? this.datePickerMinDate
      : threeYearsAgo;

    if (this.setMinDate && this.setMinDate.min === null && this.setMinDate.max === null) {
      this.startDate = null;

      switch (this.conditionCode) {
        case 'parameterization':
          this.disableDates = this.getLast7Days();
          this.endDate = new Date(this.today.setDate(this.today.getDate() - 6));
          break;
        case 'performance':
          this.disableMindate = this.datePickerMinDate;
          this.endDate = new Date(this.today.setDate(this.today.getDate() + 1));
        default:
          this.endDate = new Date(this.today.setDate(this.today.getDate() - 1));
          break;
      }

      this.isDisable.from = false;
      this.isDisable.to = false;
      this.setMinDate.min = this.today;
      this.setMinDate.max = this.today;
    } else {
      if ((this.disableEndDate && this.disableEndDate.cost && this.selection === 'cost') ||
        (this.disableEndDate && this.disableEndDate.ega &&
          this.selection === 'ega')) {
        this.isDisable.from = true;
        this.isDisable.to = true;
      } else {
        this.isDisable.from = true;
      }
      this.startDate = this.setMinDate.min;
      if (this.disableEndDate && this.setMinDate.max === null) {
        this.setMinDate.max = this.today;
      }
      if (this.setMinDate && this.setMinDate.intialRow) {
        this.isDisable.from = false;
        this.startDate = null;
      }
    }

    if (this.setMinDate && this.setMinDate.index === 0 && !this.setMinDate.isEdit) {
      this.startDateFrom = new Date(tempToday.setDate(tempToday.getDate() - 6));
      this.isDisable.from = false;
    } else {
      this.startDateFrom = this.startDate;
    }
    this.customDate = {
      from: this.setMinDate?.min,
      to: this.setMinDate?.max,
      oriFrom: this.setMinDate?.min,
      oriTo: this.setMinDate?.max,
    };
  }

  ngAfterViewChecked(): void {
    this.disabledOutOfRange();
  }

  disabledOutOfRange() {
    const calendarHost = this.el.nativeElement;
    const yearElements: NodeListOf<HTMLElement> = calendarHost.querySelectorAll('.p-yearpicker-year', 'p-yearpicker span', '.ui-yearpicker-year');

    if (yearElements && yearElements.length > 0) {
      yearElements.forEach((el) => {
        const yearVal = parseInt(el.innerText?.trim(), 10);

        if (!isNaN(yearVal)) {
          if (yearVal < this.minYear || yearVal > this.maxYear) {
            el.classList.add('custom-year-disabled');
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.25';
            el.style.color = '#a0a0a0';
            el.style.cursor = 'not-allowed';
          } else {
            el.classList.remove('custom-year-disabled');
            el.style.pointerEvents = 'auto';
            el.style.opacity = '1';
            el.style.color = '';
            el.style.cursor = 'pointer';
          }
        }
      })
    }
  }

  getLast7Days(): Date[] {
    const days = [];
    for (let i = 0; i < 6; i++) {
      const date = new Date(this.today);
      date.setDate(this.today.getDate() - i);
      days.push(date);
    }
    return days;
  }

  customDateChange() {
    if (this.customDate.from && this.customDate.to) {
      const fromDate = new Date(this.customDate.from);
      const toDate = new Date(this.customDate.to);

      // 1. Ensure fromDate is before toDate
      if (fromDate >= toDate) {
        this.selectionCorrect = false;
        return;
      }

      // 2. Calculate the minimum allowed end date (3 months after fromDate)
      let minToDate;
      if (this.conditionCode === 'performance') {
        minToDate = new Date(
          fromDate.getFullYear(),
          fromDate.getMonth(),
          fromDate.getDate()
        );
      } else {
        minToDate = new Date(
          fromDate.getFullYear(),
          fromDate.getMonth() + 1,
          fromDate.getDate()
        );
      }


      // 3. Validate that toDate is at least three months later
      this.selectionCorrect = toDate >= minToDate;
    } else {
      this.selectionCorrect = false;
    }
  }



  applyCustomDate() {
    // meit converted date (to factory local time)
    const selectedFrom = new Date(new Date(
      this.utilSer.timeStampConverter(+this.customDate.from)).setHours(0, 0, 1, 0));
    const selectedTo = new Date(new Date(
      this.utilSer.timeStampConverter(+this.customDate.to)).setHours(0, 0, 1, 0));
    const converteddate: CustomDateModel = {
      from: selectedFrom,
      to: selectedTo,
      oriFrom: this.customDate.from,
      oriTo: this.customDate.to
    };
    this.applyDate.emit(converteddate);
  }
}
